<template>
  <v-row>
    <v-col md="12">
      <!-- <v-autocomplete id="filter-customer" dense v-model="customerId" filled :items="customer_list" hide-details
        placeholder="Select Customer" label="Select Customer" solo flat
        clearable item-value="value" item-text="display_name"  v-on:change="getLocations($event)" /> -->
      <label class="v-label font-weight-500 font-size-13 text-capitalize"
        >Customer</label
      >
      <v-autocomplete
        id="filter-customer"
        dense
        v-model="customerId"
        filled
        :search-input.sync="customer_search"
        :items="customerItems"
        hide-details
        :disabled="customerItems.length == 0"
        :loading="customer_loading"
        placeholder="Select Customer"
        v-on:update:search-input="customerFilter"
        solo
        flat
        item-value="id"
        clearable
        item-text="display_name"
        v-on:change="getLocations"
      />
      <!-- return-object          v-on:change="getLocations($event)"-->
    </v-col>
    <v-col md="12">
      <label class="v-label font-weight-500 font-size-13 text-capitalize"
        >Billing Location</label
      >
      <v-autocomplete
        id="filter-billing-location"
        dense
        v-model="billingId"
        filled
        :items="billing_list"
        hide-details
        :loading="billing_loading"
        placeholder="Select Billing Location"
        solo
        flat
        clearable
        item-value="value"
        item-text="text"
      />
      <!-- v-on:change="emitValue()" -->
    </v-col>
    <v-col md="12">
      <label class="v-label font-weight-500 font-size-13 text-capitalize"
        >Site Location</label
      >
      <v-autocomplete
        id="filter-property-location"
        dense
        v-model="propertyId"
        filled
        :items="property_list"
        hide-details
        :loading="property_loading"
        placeholder="Select Site Location"
        solo
        flat
        item-value="value"
        item-text="text"
        clearable
      />
      <!--   v-on:change="emitValue()" -->
    </v-col>
  </v-row>
</template>

<script>
import {
  SET_CUSTOMER_LISTING_FILTER,
  SET_FILTER_DISPLAY_NAMES,
} from "@/core/services/store/customer.module";
import { GET, QUERY } from "@/core/services/store/request.module";
import { SearchEventBus } from "@/core/lib/search.lib";

export default {
  name: "customer-filter-listing",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    customer_list: {
      type: Array,
      default: () => [],
    },
    listingSearch: {
      type: Object,
      default: () => ({
        customer: null,
        billing: null,
        property: null,
        dates: [],
        sales_id: null,
      }),
    },
    clearFilters: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customerId: this.listingSearch?.customer || null,
      billingId: this.listingSearch?.billing || null,
      propertyId: this.listingSearch?.property || null,
      // customerId: null,
      customer: null,
      customer_search: null,
      customer_loading: false,
      new_customer_list: [],
      // billingId: null,
      billing_loading: false,
      billing_list: [],
      // propertyId: null,
      property_loading: false,
      property_list: [],
      searchTimeout: null,
      selectedCustomerCache: null,
    };
  },
  methods: {
    clearSelection() {
      this.customerId = null;
      this.customer = null;
      this.billingId = null;
      this.propertyId = null;
      this.customer_search = "";
      this.new_customer_list = [];
      this.billing_list = [];
      this.property_list = [];
      this.selectedCustomerCache = null;
      this.emitValue();
    },
    // emitValue() {
    //   this.$store.commit(SET_CUSTOMER_LISTING_FILTER, {
    //     customer: this.customerId,
    //     billing: this.billingId,
    //     property: this.propertyId,
    //   });
    // },

    emitValue() {
      const selectedCustomer =
        this.customer_list.find((c) => c.id == this.customerId) ||
        this.selectedCustomerCache;

      const selectedBilling = this.billing_list.find(
        (b) => b.id == this.billingId
      );
      const selectedProperty = this.property_list.find(
        (p) => p.id == this.propertyId
      );

      // Only emit if values have changed
      const newValues = {
        customer: this.customerId || null,
        billing: this.billingId || null,
        property: this.propertyId || null,
      };

      // Update store with new values
      this.$store.commit(SET_CUSTOMER_LISTING_FILTER, newValues);

      // Update display names in store
      this.$store.commit(SET_FILTER_DISPLAY_NAMES, {
        customerName: selectedCustomer?.display_name || "",
        billingName: selectedBilling?.text || "",
        propertyName: selectedProperty?.text || "",
      });

      // Emit to parent component
      this.$emit("update-listing-search", newValues);
    },
    updateRouteParams() {
      const queryParams = { ...this.$route.query };

      if (!this.customerId || isNaN(this.customerId) || this.customerId === 0) {
        delete queryParams.customer;
      } else {
        queryParams.customer = this.customerId;
      }

      if (!this.billingId || isNaN(this.billingId) || this.billingId === 0) {
        delete queryParams.billing;
      } else {
        queryParams.billing = this.billingId;
      }

      if (!this.propertyId || isNaN(this.propertyId) || this.propertyId === 0) {
        delete queryParams.property;
      } else {
        queryParams.property = this.propertyId;
      }

      if (JSON.stringify(queryParams) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query: queryParams }).catch((err) => {
          console.error(err);
        });
      }
    },

    customerFilter() {
      clearTimeout(this.searchTimeout);

      if (!this.customer_search) {
        this.new_customer_list = [];
        return false;
      }

      const selected = this.customer_list.find((c) => c.id == this.customerId);
      const selectedName = selected?.display_name || "";
      if (selectedName.toUpperCase() === this.customer_search.toUpperCase()) {
        this.new_customer_list = [];
        return false;
      }

      this.new_customer_list = [];
      this.billing_list = [];
      this.property_list = [];
      this.searchTimeout = setTimeout(() => {
        this.getCustomers();
      }, 2000);
    },
    getCustomers() {
      this.customer_loading = true;
      this.$store
        .dispatch(QUERY, {
          url: "filter-customer",
          data: { search: this.customer_search },
        })
        .then(({ data }) => {
          this.new_customer_list = data;
          this.customer_loading = false;
        })
        .catch((error) => {
          this.logError(error);
          this.new_customer_list = [];
          this.customer_loading = false;
        })
        .finally(() => {
          /* this.customer_list = []; */
          this.customer_loading = false;
        });
    },
    getLocations() {
      if (!this.customerId) return;
      this.billingId = null;
      this.propertyId = null;
      this.getBillingLocations();
      this.getPropertyLocations();
    },

    getBillingLocations() {
      this.billing_list = [];
      if (!this.customerId) {
        return false;
      }
      this.billing_loading = true;
      this.$store
        .dispatch(GET, { url: `filter-billing-location/${this.customerId}` })
        .then(({ data }) => {
          this.billing_list = data;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.billing_loading = false;
        });
    },
    getPropertyLocations() {
      this.property_list = [];
      if (!this.customerId) {
        return false;
      }
      this.property_loading = true;
      this.$store
        .dispatch(GET, { url: `filter-property-location/${this.customerId}` })
        .then(({ data }) => {
          this.property_list = data;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.property_loading = false;
        });
    },

    resolveSelectedCustomer() {
      if (!this.customerId) return;

      // Search in parent list
      const found = this.customer_list.find((c) => c.id == this.customerId);
      if (found) {
        this.selectedCustomerCache = found;
        return;
      }

      // Fetch if not found
      if (this.customer_loading) return;
      this.customer_loading = true;

      this.$store
        .dispatch(QUERY, {
          url: "filter-customer",
          data: { id: this.customerId },
        })
        .then(({ data }) => {
          if (Array.isArray(data) && data.length) {
            this.selectedCustomerCache = data[0];
          }
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.customer_loading = false;
        });
    },
  },
  watch: {
    customerId: function (newVal) {
      this.listingSearch.customer = Number(newVal);
      if (newVal) {
        this.resolveSelectedCustomer();
      }
      this.emitValue();
    },
    billingId: function () {
      this.listingSearch.billing = this.billingId;
      this.emitValue();
    },
    propertyId: function () {
      this.listingSearch.property = this.propertyId;
      this.emitValue();
    },
    customer_list: {
      immediate: true,
      handler() {
        this.resolveSelectedCustomer();
      },
    },
    clearFilters: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.clearSelection();
        }
      },
    },
  },
  computed: {
    customerItems() {
      const base = this.customer_list || [];
      const search =
        this.new_customer_list && this.new_customer_list.length
          ? this.new_customer_list
          : [];

      const items = [];
      if (search.length) {
        // show search results first, then append remaining parent list items
        search.forEach((s) => items.push(s));
        base.forEach((b) => {
          if (!items.find((i) => i.id == b.id)) items.push(b);
        });
      } else {
        base.forEach((b) => items.push(b));
      }

      // Ensure selected customer is present at the top
      if (
        this.customerId &&
        !items.find((c) => c.id == this.customerId) &&
        this.selectedCustomerCache
      ) {
        return [this.selectedCustomerCache, ...items];
      }
      return items;
    },
  },

  mounted() {
    this.$root.$on("clear-customer-filters", this.clearSelection);
    SearchEventBus.$on("clear-search", this.clearSelection);

    this.customer_search = "";
    this.searchTimeout = setTimeout(() => {
      this.getCustomers();
    }, 1000);

    this.customerId = this.$route.query?.customer;
    this.billingId = Number(this.$route.query?.billing);
    this.propertyId = Number(this.$route.query?.property);

    if (this.customerId) {
      this.resolveSelectedCustomer();
    }
  },
  beforeDestroy() {
    this.$root.$off("clear-customer-filters", this.clearSelection);
    SearchEventBus.$off("clear-search", this.clearSelection);
  },
};
</script>
